export default "__VITE_ASSET__Bjf1QUwI__"